import { useState, type FormEvent } from 'react';
import { api } from '@/api/client';
import { useAuth } from '../state/AuthContext';

export function SettingsOrganisationScreen() {
  const { organisations, refresh } = useAuth();
  const org = organisations[0] ?? null;
  const [name, setName] = useState(org?.name ?? '');
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    if (!org) return;
    setError(null);
    try {
      await api.authUpdateOrganisation(org.id, { name });
      await refresh();
      setMessage('Organisation updated.');
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  if (!org) {
    return (
      <section className="panel">
        <p className="muted">No organisation membership found.</p>
      </section>
    );
  }

  return (
    <section className="panel stack" data-testid="settings-organisation">
      <h2>Organisation</h2>
      <p className="muted">Slug: {org.slug}</p>
      <form className="stack" onSubmit={onSubmit}>
        <div className="field">
          <label htmlFor="org-name">Name</label>
          <input id="org-name" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        {error ? <p className="error">{error}</p> : null}
        {message ? <p className="muted">{message}</p> : null}
        <button className="btn" type="submit">
          Save organisation
        </button>
      </form>
    </section>
  );
}
